import React from 'react';
import Button from './Button';
export const Header = () => {
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/mcc-gpm" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-52">
      {children}
    </a>;
  return <header className="w-full bg-white py-8 md:py-16 px-4" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6 text-gray-800 leading-tight" data-id="element-55">
          Probeert jouw hond je iets te vertellen? 7+ signalen die je niet moet
          negeren
        </h1>
        <div className="w-full max-w-2xl mx-auto mb-8 bg-amber-100 rounded-lg p-4 border-l-4 border-amber-500" data-id="element-56">
          <p className="text-amber-800 font-medium text-lg" data-id="element-57">
            Ontdek de geheime taal van je hond zodat je begrijpt wat hij denkt,
            voelt en bedoelt
          </p>
        </div>
        <div className="flex justify-center mb-8" data-id="element-58"></div>
        <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden shadow-lg flex items-center justify-center" data-id="element-59">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/883uGZnpE5BjuokhXG3j3o/Wat-honden-gedrag-betekent.jpg" alt="Honden die signalen geven" className="w-2/3 h-auto object-cover mx-auto" data-id="element-60" />
        </div>
      </div>
    </header>;
};